import { ATLAS_APP_BASE_URL, envMap } from '@/constants';
import studentDigitalK2 from '@/assets/category/digital-classroom-activities/student-digital-k-2.jpg';
import studentDigital3to5 from '@/assets/category/digital-classroom-activities/student-digital-3-5.jpg';
import studentDigital6to8 from '@/assets/category/digital-classroom-activities/student-digital-6-8.jpg';
import studentDigital9to12 from '@/assets/category/digital-classroom-activities/student-digital-9-12.jpg';

const env = process.env.NODE_ENV?.toLowerCase() || 'production';
const envPrefix = envMap[env] || '';

const digitalClassroomActivities = [
    {
        tag: 'K–2',
        title: 'Before and After Thoughts',
        rtuGUID: '51a45e1e-7dda-450c-811b-4421da08de2d',
        reflectionQuizGUID: 'd2eba3b0-66d2-4679-ac35-07e4b2486f88',
        debriefQuizGUID: '14b78203-102e-4db5-bcff-b9e2b90274c1',
        description: 'Support early learners in reflecting on what they saw and heard with simple, interactive check-ins after a virtual visit.',
        thumbnailUrl: studentDigitalK2,
    },
    {
        tag: '3–5',
        title: 'Job Thoughts in Six Words',
        rtuGUID: '35d5eb1e-17e8-443b-a33c-f06cff4c1b0f',
        reflectionQuizGUID: '1a368abc-304e-4f0f-8aa9-e6bb4f88b60f',
        debriefQuizGUID: 'b1cdd28d-75a1-46dd-995c-4cf17377d488',
        description: 'Engage students in meaningful reflection and help them connect their virtual career visit to real-world ideas.',
        thumbnailUrl: studentDigital3to5,
    },
    {
        tag: '6–8',
        title: 'Find Your Focus',
        rtuGUID: 'edfbae37-2ecb-4ade-81ba-dc5b5edbb367',
        reflectionQuizGUID: 'cdbee560-8447-4cf2-aa1a-935d45462195',
        debriefQuizGUID: '3d5e4991-b78a-4045-9b39-f94fe07f9ed9',
        description: `Encourage deeper reflection and career exploration with structured tools that 
            help students connect their virtual career visit to their strengths, interests, and next steps.`,
        thumbnailUrl: studentDigital6to8,
    },
    {
        tag: '9–12',
        title: 'Picture Your Future',
        rtuGUID: 'e6091a18-2b0b-4864-8784-46fde329803a',
        reflectionQuizGUID: 'f50da569-47ed-4610-b2c6-358928623ced',
        debriefQuizGUID: 'a4d36774-ae23-4d6a-b652-aaaaa0502c63',
        description: `Foster critical thinking and future planning with guided reflections that support students 
            in analyzing their virtual visit and applying insights to their evolving career goals.`,
        thumbnailUrl: studentDigital9to12,
    },
].map((item) => {
    const reflectionQuiz = `https://app.${envPrefix}discoveryeducation.com/learn/player/${item.reflectionQuizGUID}`;
    const debriefQuiz = `https://app.${envPrefix}discoveryeducation.com/learn/player/${item.debriefQuizGUID}`;
    const readyToUseActivity = `${ATLAS_APP_BASE_URL}/player/${item.rtuGUID}`;
    return {
        ...item,
        links: [
            {
                icon: 'quiz',
                text: 'Reflection Quiz',
                link: reflectionQuiz,
                link_aria_label: 'opens in new window',
                target: '_blank',
            },
            {
                icon: 'quiz',
                text: 'Debrief Quiz',
                link: debriefQuiz,
                link_aria_label: 'opens in new window',
                target: '_blank',
            },
            {
                icon: 'studio',
                text: 'Ready-to-Use Activity',
                link: readyToUseActivity,
            },
        ],
    };
});

export default digitalClassroomActivities;
